import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import sx from './styles'

const ActionButtons = ({ handleCleanFilters: handleCleanFiltersProp, onSubmit }) => {
  const { filters } = useSelector((s) => s.map)

  const handleCleanFilters = () => {
    handleCleanFiltersProp()
  }

  const handleSubmit = () => {
    onSubmit(filters)
  }

  return (
    <Box sx={sx.actions}>
      <Button
        variant="text"
        onClick={handleCleanFilters}
        sx={sx.defaultButton}
      >
        <FormattedMessage id="SEARCH_CLEAN_FILTER" />
      </Button>
      <Button
        variant="contained"
        color="primary"
        sx={sx.primaryButton}
        onClick={handleSubmit}
        id="btn-search"
      >
        <FormattedMessage
          id="SEARCH"
        />
      </Button>
    </Box>
  )
}

export default memo(ActionButtons)
